import React from 'react';
import {Button} from '@mui/material';
import {createLink} from '@tanstack/react-router';
import type {ButtonProps} from '@mui/material';
import type {LinkComponent} from '@tanstack/react-router';

const ButtonBase = React.forwardRef<HTMLAnchorElement, ButtonProps<'a'>>((props, ref) => {
  return <Button ref={ref} component="a" {...props} />;
});
ButtonBase.displayName = 'ButtonBase';

const CreatedButtonLink = createLink(ButtonBase);

export const ButtonLink: LinkComponent<typeof ButtonBase> = props => {
  return <CreatedButtonLink preload="intent" {...props} />;
};
